<script>
  import { getContext, onMount } from 'svelte';
  import { fade, fly } from 'svelte/transition';
 
  import {SEARCH_COORDINATORS} from '../../graphql/coordinators';
  
  const client = getContext('apollo');

  import Loader from '../../components/ui/loader.html';
  import Coordinator from './components/coordinator.html';
  import Plus from '../../components/buttons/plus';
  import Link from '../../utils/link';

  let search = '';
  let query = client.watchQuery({ query: SEARCH_COORDINATORS, fetchPolicy: 'network-only', variables: {search} });
  let results = {loading: true};

  function setResponse({data, loading, error, networkStatus}) {
    results = {
      loading,
      page: data && data.coordinators ? data.coordinators.page : 1,
      total: data && data.coordinators ? data.coordinators.total : 0,
      coordinators: data && data.coordinators ? data.coordinators.docs : []
    }
  }

  const subscription = query.subscribe({
    next: nextResult => {
      setResponse(nextResult);
    },
    error: error => {
      setResponse({error, loading: false});
    }
  });

  function searchPeople() {
    query.refetch({search, page: 1});
  }

  function loadMore() {
    query.fetchMore({
      variables: {
        search,
        page: results.page + 1
      },
      updateQuery: (prev, {fetchMoreResult}) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, {
          people: {
            ...fetchMoreResult.coordinators,
            docs: [...prev.coordinators.docs, ...fetchMoreResult.coordinators.docs]
          }
        });
      }
    });
  }
</script>




<div class="grid-x grid-margin-x">
  <div class="cell small-12 medium-6">
    <h1>{results.total || 0} Program Coordinators</h1>
  </div>
  <div class="cell small-12 medium-6 text-right">
    <Link href="/coordinators/new">
      <Plus label="ADD COORDINATOR" />
    </Link>
  </div>
  <div class="cell small-12 medium-12">
    {#if results.loading}
      <Loader></Loader>
    {/if}
    {#if !results.loading}
      <div class="grid-x grid-margin-x small-up-1 medium-up-3">
        {#each results.coordinators as coordinator, i}
          <div class="cell">
            <Coordinator coordinator={coordinator} />
          </div>
        {/each}
      </div>
    {/if}
  </div>
</div>
